// NDSC's Modal applies scroll-lock styles to <body> (position: fixed,
// overflow: hidden, nds-no-scroll class) via useScrollLock and a useEffect
// that schedules `body.classList.add('nds-no-scroll')` after a ~250ms
// timeout. When a modal unmounts or its isOpen flickers, the unmount
// cleanup removes the class but the stale timeout re-adds it afterward,
// leaving the body locked with no visible modal. Clearing immediately +
// again after a 300ms delay covers both cases.
//
// Shared between ProductAddedModal and ErrorWarningModal — keep in one
// place so future tweaks to the NDSC workaround don't drift.
var releaseScrollLock = function releaseScrollLock() {
  if (typeof document === 'undefined') return;
  var body = document.body;
  var clear = function clear() {
    body.classList.remove('nds-no-scroll', 'nds-override-urlbar');
    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
  };
  clear();
  setTimeout(clear, 300);
};
export default releaseScrollLock;